/**
 * The product's name as people see it (D39). The code, packages, Compose projects and databases keep
 * the codename `wednesday`.
 */
export const PRODUCT_NAME = 'Tasklist';

/** The company that owns the product (D39, D44), named on the sign-in pages, in emails and link previews. */
export const PRODUCT_OWNER = 'Swaidan International';

/** The ownership line shown under the sign-in pages and at the foot of every email. */
export const PRODUCT_CREDIT = `${PRODUCT_NAME} · owned by ${PRODUCT_OWNER}`;
